import React, { useEffect, useState } from 'react';
import { BasicDialog, Colors } from 'library';
import { Card, EmptyText, Link, Row, Stack, Text } from 'library/ui';
import { CheckRounded } from '@mui/icons-material';

import { useNotificationContext } from 'parent-portal/notifications/NotificationContext/NotificationContext';

import type { NotificationType } from 'models';

export function Notification({ notification }: { notification: NotificationType }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [read, setRead] = useState<boolean>(notification.marked_as_read);
    const { notifications, clickNotification, actionMessage, setActionMessage, markNotificationRead } =
        useNotificationContext();

    function closeActionDialog() {
        setActionMessage(undefined);
    }

    function markRead() {
        setLoading(true);
        markNotificationRead(notification, () => {
            setLoading(false);
        });
    }

    useEffect(() => {
        const updatedNotification = notifications.find((n) => n.id === notification.id);

        if (updatedNotification && updatedNotification.marked_as_read === true) {
            setRead(true);
        }
    }, [notifications]);

    return (
        <Card padding="sm" tone="muted">
            <Stack gap="sm">
                <Row justify="between" align="start">
                    <Row gap="sm">
                        <Link onClick={() => clickNotification(notification)} underline={false} color={Colors.primary}>
                            <Text size="xs" weight="bold">
                                {notification.added_at}
                            </Text>
                        </Link>
                        <Text size="xs" tone="secondary">
                            {notification.location_name}
                        </Text>
                    </Row>
                    {loading && <EmptyText padding="none">Loading...</EmptyText>}
                    {!loading &&
                        (read ? (
                            <CheckRounded style={{ color: Colors.primary, height: 20, width: 20 }} />
                        ) : !notification.hide_mark_as_read ? (
                            <Link onClick={markRead} color={Colors.primary}>
                                <Text size="xs">Mark Read</Text>
                            </Link>
                        ) : null)}
                </Row>
                <Link onClick={() => clickNotification(notification)} underline={false} color={Colors.primary}>
                    <Text align="left">{notification.message}</Text>
                </Link>
            </Stack>
            <BasicDialog
                closeButton
                buttonEnabled
                onSubmit={closeActionDialog}
                buttonText="OK"
                isOpen={!!actionMessage}
                onClose={closeActionDialog}
            >
                <Text>{notification.message}</Text>
            </BasicDialog>
        </Card>
    );
}
